import { motion } from 'framer-motion';
import { FiDownloadCloud, FiUserPlus } from 'react-icons/fi';
import { useEffect, useState } from 'react';
import './SetupDownload.scss';
import fnc from '../mymod/commFunction';
import SignUpModal from '../LoginSection/SignUpModal';
import FindIdModal from '../LoginSection/FindIdModal';
import FindPasswordModal from '../LoginSection/FindPasswordModal';
import DeleteAccountModal from '../LoginSection/DeleteAccountModal';




const SetupDownload = ({ disableHomePageRoutesApi = false }) => {


    const [firstCall, setFirstCall] = useState('');
    const [showSignUpModal, setShowSignUpModal] = useState(false);
    const [showFindIdModal, setShowFindIdModal] = useState(false);
    const [showFindPwModal, setShowFindPwModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    useEffect(() => {
        if (disableHomePageRoutesApi) return;
        fncSelect_firstCall('firstCall');
    }, [disableHomePageRoutesApi]);

    function fncSelect_firstCall(title) {
        fnc.sendAxios('/homePageRoutes/selectSetting', { title }, (res) => {
            if (res && Array.isArray(res)) {
            const settingData = res[0];
            setFirstCall(settingData.value);

            } else {
            alert('데이터를 불러오는 데 실패했습니다.');
            }
        });

    }

    function handleDownloadClick() {
        if (!disableHomePageRoutesApi) {
            fnc.sendAxios('/homePageRoutes/increaseViewCount', { pageKey: 'setup_download' }, () => {});
        }
        if (typeof window.gtag_report_conversion === 'function') {
            window.gtag_report_conversion();
        }
    }


    //-------------------------------------------------------------
    return (
        <section className="setup-download" id="setup-download">
            <div className="container">
                <motion.article
                    className="setup-panel"
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.25 }}
                    transition={{ duration: 0.48 }}
                >
                    <div className="setup-content">
                        <div className="setup-badges">
                            {/* <p className="setup-eyebrow">시즌1</p>
                            <span className="setup-beta">시즌2 업데이트 예정</span> */}
                        </div>
                        <h2 className="setup-title">설치파일 다운로드</h2>
                        <p className="setup-description">
                            업데이트를 통해 더욱 정교한 작업 환경으로 확장해 나가고 있습니다.
                        </p>

                        <div className="setup-meta" aria-label="설치 정보">
                            <span>Windows 10+</span>
                            <span>최신 버전 제공</span>
                            <span>즉시 설치 가능</span>
                        </div>
                    </div>

                    <div className="setup-cta">
                        {/* <p className="setup-notice">회원가입은 설치파일에서 진행해주세요.</p> */}
                        {/* <p className='firstCall'>최초 가입시 PDF {firstCall} 페이지 변환 무료 충전</p> */}
                        <a
                            className="setup-download-btn"
                            href="https://mathautogen.s3.ap-northeast-2.amazonaws.com/public/setup_%EB%A7%A4%EC%93%B0%ED%85%8C%EC%9D%BC%EB%9F%AC_v2.msi"
                            target="_blank"
                            rel="noreferrer"
                            download
                            onClick={handleDownloadClick}
                        >
                            <FiDownloadCloud size={20} />
                            <span>설치파일 다운로드</span>
                        </a>
                        {/* <p className="setup-help">
                            다운로드 후 압축을 해제한 뒤 실행 파일로 설치를 진행하세요.
                        </p> */}
                        <p className="setup-contact">
                            문의 : <a href="tel:01096828801">010-9682-8801</a>
                        </p>
                        <button
                            className="setup-signup-btn"
                            type="button"
                            onClick={() => setShowSignUpModal(true)}
                        >
                            <FiUserPlus size={18} />
                            <span>회원가입</span>
                        </button>
                        <div className="setup-find-links">
                            <button type="button" onClick={() => setShowFindIdModal(true)}>아이디 찾기</button>
                            <span className="divider">|</span>
                            <button type="button" onClick={() => setShowFindPwModal(true)}>비밀번호 찾기</button>
                            <span className="divider">|</span>
                            <button type="button" onClick={() => setShowDeleteModal(true)}>계정 삭제</button>
                        </div>
                    </div>
                </motion.article>
            </div>
            {showSignUpModal && <SignUpModal onClose={() => setShowSignUpModal(false)} />}
            {showFindIdModal && <FindIdModal onClose={() => setShowFindIdModal(false)} />}
            {showFindPwModal && <FindPasswordModal onClose={() => setShowFindPwModal(false)} />}
            {showDeleteModal && <DeleteAccountModal onClose={() => setShowDeleteModal(false)} />}
        </section>
    );
};

export default SetupDownload;
